import type { Immutable } from "immer";

import type { ProductUpsellModalBlock, templates } from "@reactivated";

export type UpsellBlockValue = ProductUpsellModalBlock;

export type UpsellSlideValue = NonNullable<UpsellBlockValue["slides"]>[number];

type BundleModalPagePick = Immutable<{
    bundle_modal: NonNullable<
        templates.ModularConfiguratorTemplate["bundle_modal_page"]
    >["bundle_modal"];
}> | null;

export const extractUpsellBlock = (
    bundleModalPage: BundleModalPagePick,
): Immutable<UpsellBlockValue> | null => {
    if (!bundleModalPage) {
        return null;
    }
    const stream = bundleModalPage.bundle_modal;
    if (!stream || stream.value.length === 0) {
        return null;
    }
    const first = stream.value[0];
    return first.type === "upsell" ? first.value : null;
};
